"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointDeletedEvent = void 0;
class EndpointDeletedEvent {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EndpointDeletedEvent.attributeTypeMap;
    }
}
exports.EndpointDeletedEvent = EndpointDeletedEvent;
EndpointDeletedEvent.discriminator = undefined;
EndpointDeletedEvent.attributeTypeMap = [
    {
        "name": "data",
        "baseName": "data",
        "type": "EndpointDeletedEventData",
        "format": ""
    },
    {
        "name": "type",
        "baseName": "type",
        "type": "EndpointDeletedEventTypeEnum",
        "format": ""
    }
];
//# sourceMappingURL=EndpointDeletedEvent.js.map